var dom = require('js-utils/dom');
var getOffset = require('js-utils/get-offset');
var config = require('./config');

var AUTO_HIDE_THRESHOLD = 100;

var sectionAnchors = dom.toArray(
	dom.all('body > .contentWrapper > section > span.anchor')
).reverse();

var nav = dom.byId('navigation');
var navLinks = dom.toArray(dom.all(nav, 'a'));
var mainNavLinks = dom.toArray(dom.all(dom.byId('mainnav'), 'a'));
var subNavWrapper = dom.byClass(nav, 'subnav')[0];

var autoHideEnabledSite =
	subNavWrapper.getAttribute('data-auto-hide') === 'true';

var lastScrollPos = 0;

function onScroll() {
	var scrollTop =
		document.documentElement.scrollTop || dom.byTag('body')[0].scrollTop;

	var currentAnchor = null;
	var activeId = null;

	var autoHideEnabled =
		autoHideEnabledSite && config.websiteOuterWidth < nav.offsetWidth;

	sectionAnchors.some(anchor => {
		var anchorTop = getOffset(anchor).top;

		if (anchorTop <= scrollTop + 1) {
			activeId = anchor.id;
			currentAnchor = anchor;
			return true;
		}
	});

	if (null === activeId) {
		activeId = sectionAnchors[sectionAnchors.length - 1].id;
	}

	navLinks.forEach(link => {
		var href = link.getAttribute('href');

		var active = !!link.getAttribute('data-active')
			|| href.match(/^\#\w+/) && href.substr(1) === activeId;

		link.className = active ? 'active' : '';
	});

	dom.forEach(subNavWrapper.children, subNav => {
		var active =
			activeId === subNav.getAttribute('data-parent')
			|| !!subNav.getAttribute('data-active');
		subNav.className = active ? 'active' : '';
	});

	var theme = null;
	if (currentAnchor && currentAnchor.getAttribute('data-theme')) {
		theme = currentAnchor.getAttribute('data-theme');
	}

	dom.forEach(subNavWrapper.children, subNav => {
		var active =
			activeId === subNav.getAttribute('data-parent')
			|| !!subNav.getAttribute('data-active');

		if (active && autoHideEnabled) {
			active =
				scrollTop < lastScrollPos // scroll up
				|| scrollTop < AUTO_HIDE_THRESHOLD; // scroll pos. above threshold
		}

		subNav.className = active ? 'active' : '';
	});

	lastScrollPos = scrollTop;
}

dom.on('scroll', onScroll);
onScroll();

var menuButton = dom.byClass(nav, 'menu')[0];
dom.on(menuButton, 'click', function () {
	var active = dom.toggleClass(menuButton, 'active');

	var mainNav = dom.byClass(nav, 'mainnav')[0];
	var subNav = dom.byClass(nav, 'subnav')[0];

	var func = active ? dom.addClass : dom.removeClass;
	func(mainNav, 'active');
	func(subNav, 'active');
});

mainNavLinks.forEach(link => {
	var href = link.getAttribute('href');
	dom.on(link, 'mouseover', function () {
		var hoveredId = href.substr(href.indexOf('#')+1);

		dom.forEach(subNavWrapper.children, subNav => {
			var subNavId = subNav.getAttribute('data-parent');
			var hovered = (subNavId === hoveredId);
			subNav.className = hovered?'active':'';
		});
	});
});